module.exports = __webpack_public_path__ + "static/img/sl04.d3e00c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sl04.jpg
// module id = ph+K
// module chunks = 0